import { ErrorModel } from '@era/app';
import { ModelNameFlags } from '@era/settings-sdk';
import { createActionGroup, props } from '@ngrx/store';
import { Category } from '../router/category';
import { RestrictionProfileConfiguration } from './category-restriction-profile-configuration.state';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const CategoryRestrictionProfileConfigurationResolverActions = createActionGroup({
  source: 'Restriction Profile Configuration resolver',
  events: {
    'Category Restriction Profile Configuration requested': props<{
      category: Category;
      modelNames: ModelNameFlags[];
    }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const CategoryRestrictionProfileConfigurationApiActions = createActionGroup({
  source: 'Restriction Profile Configuration API',
  events: {
    'Restriction Profile Configuration loaded': props<{ configurations: RestrictionProfileConfiguration[] }>(),
    'Restriction Profile Configuration loaded failed': props<{ error: ErrorModel }>(),
    'Restriction Profile Configuration set': props<{
      category: Category;
      configurations: RestrictionProfileConfiguration[];
    }>(),
    'Restriction Profile Configuration set failed': props<{ error: ErrorModel }>(),
  },
});

// ============================================================================
// VIEW ACTIONS (Group - using createActionGroup)
// ============================================================================

export const CategoryRestrictionProfileConfigurationViewActions = createActionGroup({
  source: 'Restriction Profile Configuration Category view',
  events: {
    'Restriction Profile Configuration selected': props<{
      category: Category;
      profiles: RestrictionProfileConfiguration[];
    }>(),
  },
});
